import type { PropsWithChildren } from 'react';
import { Deactivation2 } from '@elfsight/widget-deactivation';
import { useSettings } from '@wu/widget-core';
import type { SetElement } from 'react-use-rect';
import { meta } from '../../meta';

const { appAlias } = meta;

type DeactivationProps = PropsWithChildren<{
  childrenRef: SetElement;
}>;

export function Deactivation({ childrenRef, children }: DeactivationProps) {
  const { displayDeactivation, deactivationURL } = useSettings();

  return (
    <Deactivation2
      childrenRef={childrenRef}
      appAlias={appAlias}
      displayDeactivation={displayDeactivation}
      deactivationURL={deactivationURL}
    >
      {children}
    </Deactivation2>
  );
}
